import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const settlementsAdapter = getAdapter({ idFieldName: 'id' });

const settlementsSlice = createSlice({
  name: 'settlements',
  initialState: settlementsAdapter.getInitialState(),
  reducers: {
    setSettlements: (state, { payload: { settlements } }) => {
      settlementsAdapter.setAll(state, settlements);
    },
  },
});

const selectors = settlementsAdapter.getSelectors(({ settlements }) => settlements);

export const getSettlements = (state) => selectors.selectAll(state);

export const { setSettlements } = settlementsSlice.actions;

export default settlementsSlice.reducer;
